module.exports = __webpack_public_path__ + "img/windAndRain.9c7b4f8e.png";